import React from 'react';
import { CircularProgress } from '@mui/material';
import { LoadingContainerStyle } from './style';

export default function LoadingContainer({ children, isLoading }) {
  if (isLoading)
    return (
      <LoadingContainerStyle>
        <CircularProgress color="success" disableShrink />
      </LoadingContainerStyle>
    );

  return <LoadingContainerStyle>{children}</LoadingContainerStyle>;
}
